import React from 'react';
import {Link} from 'react-router-dom';
import {
    Card, CardBlock, CardGroup, Button,
    ListGroup, ListGroupItem
} from 'reactstrap';

import {api, request, API_URL} from '../../actions/_request';

import FaPaperplaneO from 'react-icons/lib/fa/paper-plane-o';


class Term extends React.Component {

	constructor(props) {

		super(props)

		this.state = {
			ticket: { cliente: {}},
			cliente: null,
			data:[],
			validar:[]
					};
	}

	componentDidMount() {
  // console.log('fecha--->',this.props.fecha);
var res = this.props.fecha.split("-");
var mes= parseInt( res[1]);
var año = parseInt( res[0]);
// console.log('fecha date--->',date);
// console.log('mes--->',mes);
mes--;
if(mes==0)
{
	mes=12;
	año--;
}

var fecha1=año+'-'+mes+'-01';
var fecha2=año+'-'+mes+'-30';
var user =this.props.id;
var ruta=this.props.datos;
if(mes==2)
{
  fecha2=año+'-'+mes+'-28'
}
		 let self = this;

		api().get("/reporte/produccionindividual/"+ user + "/" +fecha1 + "/" + fecha2)
        .then(function(response)
        {
            self.setState({
                validar : response.data
            });        
         api().get(ruta)
        .then(function(response)
        {
            self.setState({
                data : response.data
            });        
         
        });  

        });

		 
        
	

	}

	 formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}


	render() {

		const {ticket,data,validar} = this.state;
		let bandera=0;

		
		
			if (typeof(validar[0]) != "undefined") {
				
				bandera=parseFloat( validar[0].actual);



				
			}



	

		 let precio=parseFloat(data.precio , 10);
		 let costo=parseFloat(data.costo , 10);
		 let servicios =parseFloat(data.servicios , 10);	
		 let total_venta=precio-costo;
	     let total=total_venta+servicios;
	     let bono="No";
	     let total_comision=0;
	     let total_total=0;
	     let comision=parseFloat(data.comision , 10);
	     let meta=parseFloat(data.meta , 10);
	     if(parseFloat(data.departamento)!=1)
	     {
	     	// if(parseFloat(data.departamento)==3){
       //         total_venta=(precio/2);
       //         total=total_venta+servicios;
              


	     	// }
	     	
	     	if(meta<total)
	     	{
	     		bono="600";
	     		total_comision=((total-meta)/100)*parseFloat(comision , 10);

	     		if(bandera<100){
	     			bono="No"
	     			total_total=total_comision;
	     		}else{

	     			total_total=(parseFloat(bono, 10)+total_comision).toFixed(2);
	     			bono='$'+new Intl.NumberFormat().format(parseFloat(bono, 10));
	     		}
	     		
	     	}


	     }else
	     {
	     	
	     	total_venta=precio;
	        total=total_venta;
	     	
	     
	     	if(meta<total)
	     	{
	     		bono="No";
	     		total_comision=((total-meta)/100)*parseFloat(comision , 10);
	     		total_total=total_comision;

	     	}



	     }


		return (
		     <div className="view">
		        <div className=" view d-flex justify-content-center align-items-center flex-column fondo_blanco">
		           
		                <CardBlock style={{width: '100%'}} >
		                    <div className="d-flex justify-content-between flex-wrap">
		                        <span style={{color: '#ED0303', fontSize: '27px'}}>Maxicomm</span>
		                        <div>
		                            <h4 className="text-uppercase">Reporte Comisiones</h4>
		                            
		                        </div>
		                    </div>
		                    <hr/>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <h5>Maxicomm</h5>
		                                <address>
		                                    Macheros 366, entre 3era.<br/>
		                                    y 4ta., Zona Centro C.P. 22800 <br/>Ensenada, Baja California
		                                    <br/>Tel. (646) 178-8008
		                                </address>
		                            </CardBlock>
		                        </Card>
		                        <Card>
		                            <CardBlock>
		                                <h5>Empleado</h5>
		                                <address>
		                                    {data.nombre || '-'}<br/>
		                                    {data.nombre_dep || 'Otros'}
		                                    
		                                </address>
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                    <hr/>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <p>Meta mensual : { this.formateo( data.meta)|| this.formateo(32500)} </p>
		                                
		                                <p>Total de ventas : {this.formateo(data.precio) || ''} </p>
		                                 	
		                                
		                                   {
		                                	(parseInt(data.departamento)!==1&&parseInt(data.departamento)!==3)&&		                               
		                                    <p>Total del costo de lo vendido: {this.formateo(data.costo) || ''}</p>
		                                  }
		                            
		                                 {
		                                	(parseInt(data.departamento)!==1)&&		 
		                                <p>servicios: {this.formateo(data.servicios) || this.formateo(0)} </p>
		                                }
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                    <CardGroup>
		                    	<Card>
		                    		<CardBlock>
		                    		 {
		                                	(parseInt(data.departamento)!==1)&&		
		                    			<p>Total de la utilidad:{this.formateo(total_venta)}</p>
		                    		}
		                    		{
		                                	(parseInt(data.departamento)===1)&&		
		                    			<p>Total Venta:{this.formateo(total_venta)}</p>
		                    		}
		                    			 {
		                                	(parseInt(data.departamento)!==1)&&		 
		                    			<p>Total servicios: {this.formateo(data.servicios)  || '0'} </p>
		                    		}
		                    			<p>Total:{this.formateo(total)} </p>
		                    		</CardBlock>
		                    	</Card>
		                    </CardGroup>
		                    <CardGroup>
		                        <Card>
		                            <CardBlock>
		                                <p>Bono Cumplimiento: </p>
										<br/><br/>{bono}
		                            </CardBlock>
		                        </Card>
		                        <Card>
		                            <CardBlock>
		                                <p>%comision: </p>
		                                <br/><br/>{comision }%
		                            </CardBlock>
		                        </Card>
		                        <Card>
		                            <CardBlock>
		                                <p>Total Comision:</p>
		                                <br/><br/>{this.formateo(total_comision)}
		                            </CardBlock>
		                        </Card>
		                        <Card>
		                            <CardBlock>
		                                <p>Total:</p>
		                                <br/><br/>{this.formateo(total_total)}
		                            </CardBlock>
		                        </Card>
		                    </CardGroup>
		                    
		                </CardBlock>
		           

		        </div>
		    </div>
		)
	}

}


export default Term


// WEBPACK FOOTER //
// ./src/views/reportes/reporteComisiones.js